import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "form-action-buttons",
  templateUrl: "form-action-buttons.component.html",
})
export class FormActionButtonsComponent {
  // Required inputs
  @Input() formGroup: FormGroup;

  // Optional inputs
  @Input() isReadOnly: boolean = false;
  @Input() saveDisabled?: boolean;
  @Input() cancelDisabled?: boolean;
  @Input() saveLabel: string = "save";
  @Input() cancelLabel: string = "cancel";

  // Outputs
  @Output() saveClick = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();

  /**
   * Determines if the save button should be enabled
   * Default logic: form must be dirty and valid
   * Can be overridden by parent via saveDisabled input
   */
  get canSave(): boolean {
    if (this.saveDisabled !== undefined) {
      return !this.saveDisabled;
    }
    return this.formGroup && this.formGroup.dirty && this.formGroup.valid;
  }

  /**
   * Determines if the cancel button should be enabled
   * Default logic: form must be dirty
   * Can be overridden by parent via cancelDisabled input
   */
  get canCancel(): boolean {
    if (this.cancelDisabled !== undefined) {
      return !this.cancelDisabled;
    }
    return this.formGroup && this.formGroup.dirty;
  }

  /**
   * Handles save button click
   * Emits saveClick event to parent
   */
  onSave(): void {
    this.saveClick.emit();
  }

  /**
   * Handles cancel button click
   * Emits cancelClick event to parent
   */
  onCancel(): void {
    this.cancelClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/form-action-buttons/form-action-buttons.component.ts